import React from 'react';

import MonitoringTable from '@organisms/Tables/Enterprise/MonitoringTable';

const EnterpriseMonitoring = () => {
  return <MonitoringTable />;
};

export default EnterpriseMonitoring;
